import { useEffect, useState } from 'react';
import Modal from '@/components/ui/Modal';
import Botao from '@/components/ui/Botao';
import Campo from '@/components/ui/Campo';
import type { MotivoServir } from '../types';

const OPCOES: { valor: MotivoServir; rotulo: string }[] = [
  { valor: 'nao_veio', rotulo: 'Não veio às formações' },
  { valor: 'pediu', rotulo: 'Pediu para não servir' },
  { valor: 'outro', rotulo: 'Outro' },
];

interface Props {
  aberto: boolean;
  titulo: string;
  mensagem?: string;
  salvando: boolean;
  aoConfirmar: (motivo: MotivoServir, obs: string | null) => void;
  aoFechar: () => void;
}

// Folha de escolha do motivo para tirar alguém da montagem.
export default function EscolherMotivo({
  aberto,
  titulo,
  mensagem,
  salvando,
  aoConfirmar,
  aoFechar,
}: Props) {
  const [motivo, setMotivo] = useState<MotivoServir | null>(null);
  const [obs, setObs] = useState('');

  useEffect(() => {
    if (aberto) {
      setMotivo(null);
      setObs('');
    }
  }, [aberto]);

  const faltaTexto = motivo === 'outro' && obs.trim().length === 0;
  const podeConfirmar = motivo !== null && !faltaTexto;

  return (
    <Modal
      aberto={aberto}
      titulo={titulo}
      aoFechar={aoFechar}
      rodape={
        <div className="flex gap-3">
          <Botao variante="secundario" className="flex-1" onClick={aoFechar}>
            Voltar
          </Botao>
          <Botao
            variante="perigo"
            className="flex-1"
            carregando={salvando}
            disabled={!podeConfirmar}
            onClick={() => {
              if (!motivo) return;
              aoConfirmar(motivo, motivo === 'outro' ? obs.trim() : null);
            }}
          >
            Confirmar
          </Botao>
        </div>
      }
    >
      {mensagem && <p className="mb-3 text-sm text-foreground-600">{mensagem}</p>}
      <div className="flex flex-col gap-2">
        {OPCOES.map((o) => {
          const ativo = motivo === o.valor;
          return (
            <button
              key={o.valor}
              type="button"
              onClick={() => setMotivo(o.valor)}
              className={`flex cursor-pointer items-center gap-2 rounded-2xl border px-4 py-3 text-left text-sm font-semibold transition-colors ${
                ativo
                  ? 'border-primary-400 bg-primary-50 text-primary-700'
                  : 'border-secondary-200 bg-white text-foreground-800 hover:bg-background-50'
              }`}
            >
              <span className="flex h-5 w-5 items-center justify-center">
                <i className={ativo ? 'ri-radio-button-line' : 'ri-checkbox-blank-circle-line'} />
              </span>
              {o.rotulo}
            </button>
          );
        })}
      </div>
      {motivo === 'outro' && (
        <div className="mt-3">
          <Campo
            rotulo="Escreva o motivo"
            value={obs}
            onChange={setObs}
            maxLength={140}
            placeholder="Por quê?"
            ajuda="Obrigatório escrever o motivo."
          />
        </div>
      )}
    </Modal>
  );
}